import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/categoriesAsso`;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/// GET
export const getAllCategoriesAsso = async (params = {}) => {
  try {
    const response = await axios.get(`${apiUrl}/getAllCategoriesAsso`, {
      params,
      headers: authHeaders(),
    });

    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des catégories:", error);
    return [];
  }
};

export const getCategoryAssoById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/getCategoryAssoById/${id}`, {
      headers: authHeaders(),
    });

    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération de la catégorie:", error);
    return null;
  }
};

export const getCategoryAssoBySlug = async (slug) => {
  try {
    const response = await axios.get(
      `${apiUrl}/getCategoryAssoBySlug/${slug}`,
      {
        headers: authHeaders(),
      }
    );

    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération de la catégorie (slug):", error);
    return null;
  }
};

/// POST
export const createCategoryAsso = async (newCategory) => {
  try {
    const response = await axios.post(
      `${apiUrl}/addCategoryAsso`,
      newCategory,
      {
        headers: authHeaders(),
      }
    );

    if (response.status !== 201 && response.status !== 200) {
      throw new Error("Failed to add new category");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout d'une catégorie:", error);
    return null;
  }
};

/// PUT
export const updateCategoryAsso = async (category) => {
  try {
    const response = await axios.put(
      `${apiUrl}/updateCategoryAsso/${category.id}`,
      category,
      {
        headers: authHeaders(),
      }
    );

    if (response.status !== 200) throw new Error("Failed to update category");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification d'une catégorie:", error);
    return null;
  }
};

/// DELETE
export const deleteCategoryAsso = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/removeCategoryAsso/${id}`, {
      headers: authHeaders(),
    });

    if (response.status !== 200) throw new Error("Failed to delete category");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression de la catégorie:", error);
    return null;
  }
};